import decodeVin from 'vin-decode';

const rules = {
  numeric: {
    valid: (v) => {
      if (!v) return true;
      else return v && /^[0-9]+$/.test(v);
    },
    message: 'Must be a number'
  },
  numeric_stripped: {
    valid: (v) => {
      try {
        parseInt(v.replace(/[^0-9]/g, ''));
        return true;
      } catch (e) {
        return false;
      }
    },
    message: 'Must be a number'
  },
  numeric_stripped_fixed: (limit) => ({
    valid: (v) => {
      try {
        const _v = v.replace(/[^0-9]/g, '');
        return _v.length === limit;
      } catch (e) {
        return false;
      }
    },
    message: 'Must be a ' + limit + '-digit number'
  }),
  numeric_fixed: (limit) => ({
    valid: (v) => {
      if (!v) return true;
      else return new RegExp('^[0-9]{' + limit + '}$').test(v);
    },
    message: 'Must be a ' + limit + '-digit number'
  }),
  numeric_bounded: (lower, upper) => ({
    valid: (v) => {
      if (!v) return false;
      try {
        const _v = parseInt(v);
        return _v >= lower && _v <= upper;
      } catch (e) {
        return false;
      }
    },
    message: 'Must be between ' + lower + ' and ' + upper
  }),
  phone: {
    valid: (v) => {
      console.log(v);
      return v && /^\+?[0-9]{10,12}$/.test(v.replace(/[\s()[\]]/g, ''));
    },
    message: 'Must be a valid phone number'
  },
  email: {
    valid: (v) => v && /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/.test(v),
    message: 'Must be a valid email'
  },
  abn: {
    valid: (v) => {
      try {
        var total = 0;
        const start = (v - 10000000000 + '').padStart(11, 0);
        if (start.length > 11) return false;
        for (let i = 0; i < start.length; i++) {
          total += parseInt(start[i]) * (i === 0 ? 10 : (i - 1) * 2 + 1);
        }
        return total / 89.0 === Math.floor(total / 89.0);
      } catch (e) {
        return false;
      }
    },
    message: 'Must be a valid ABN'
  },
  acn: {
    valid: (v) => {
      try {
        const weight = [8, 7, 6, 5, 4, 3, 2, 1];
        const start = v + '';
        if (start.length !== 9) return false;
        var total = 0;
        for (let i = 0; i < weight.length; i++) {
          total += parseInt(start[i]) * weight[i];
        }
        return 10 - (total % 10) === (start[8] === '0' ? 10 : parseInt(start[8]));
      } catch (e) {
        return false;
      }
    },
    message: 'Must be a valid ACN'
  },
  tfn: {
    valid: (v) => {
      try {
        const weight = [1, 4, 3, 7, 5, 8, 6, 9, 10];
        const start = (v + '').padStart(9, 0);
        if (start.length > 9) return false;
        var total = 0;
        for (let i = 0; i < start.length; i++) {
          total += parseInt(start[i]) * weight[i];
        }
        return total / 11.0 === Math.floor(total / 11.0);
      } catch (e) {
        return false;
      }
    },
    message: 'Must be a valid Tax File Number'
  },
  medicare: {
    valid: (v) => {
      try {
        const weight = [1, 3, 7, 9, 1, 3, 7, 9];
        const start = v + '';
        if (start.length !== 10) return false;
        var total = 0;
        for (let i = 0; i < start.length - 2; i++) {
          total += parseInt(start[i]) * weight[i];
        }
        return total % 10 === parseInt(start[8]);
      } catch (e) {
        return false;
      }
    },
    message: 'Must be a valid Medicare number'
  },
  vin: {
    valid: (v) => {
      return decodeVin(v) === false ? false : true;
    },
    message: 'Must be a valid VIN'
  },
  accountNumber: (len = 9) => ({
    valid: (v) => v && !isNaN(v) && v.length <= len,
    message: `Must be less than or equal to ${len} numbers`
  }),
  min: (len, field = 'This field', type = 'characters') => ({
    valid: (v) => v && v.length >= len,
    message: `${field} can't less than ${len} ${type}`
  }),
  max: (len, field = 'This field', type = 'characters') => ({
    valid: (v) => v && v.length <= len,
    message: `${field} can't over ${len}`
  }),
  length: (min, max, field = 'This field', type = 'characters') => ({
    valid: (v) => v && v.length >= min && v.length <= max,
    message:
      min === max
        ? `${field} should be ${max} ${type}`
        : `${field} should between ${min} and ${max} ${type}`
  })
};

export default rules;
